export default {
  "Very High": [9, 0],
  High: [12, 10],
  Medium: [14, 13],
  Low: [18, 15],
  "No Risk": [23, 19],
  None: [null, null]
};
